import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pointstatus',
    standalone: false
})
export class PointStatusPipe implements PipeTransform {
  transform(value: number): any {
    switch (value) {
      case 0:
        return 'Draft';
      case 100:
        return 'Done';
      default:
    }
  }
}

import { InspectionPointService } from '../shared/services/index';

@Pipe({
    name: 'notapplicablereasonpipe',
    standalone: false
})
export class NotapplicableraisonPipe implements PipeTransform {
  public notApplicableValues: any;

  constructor(private service: InspectionPointService) {
    this.notApplicableValues = this.service.getNotApplicableValues();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.notApplicableValues);
  }
}
